import Navigation from './Navigation';
import Branding from './Branding';
import { useEffect, useRef } from 'react';
const Header = () => {
	const headerRef = useRef(null);

	useEffect(() => {
		const updateHeaderHeight = () => {
			if (headerRef.current) {
				const height = headerRef.current.offsetHeight;
				document.documentElement.style.setProperty('--header-height', `${height}px`);
			}
		};

		// Set initial height
		updateHeaderHeight();

		// Update height on window resize
		window.addEventListener('resize', updateHeaderHeight);

		// Cleanup listener and CSS variable on unmount
		return () => {
			window.removeEventListener('resize', updateHeaderHeight);
			document.documentElement.style.removeProperty('--header-height');
		};
	}, []);

	return (
		<header id="header">
			<div className="relative bg-white">
				<div className="container py-[2rem]" ref={headerRef}>
					<div className="flex gap-12 justify-between items-center">
						<div className="flex items-center">
							<Branding />
						</div>
						<div className="flex items-center">
							<Navigation />
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
